import React from "react";
export const StatSection = ({ title, subTitle, textColor }) => (React.createElement("div", { className: "stat-section" },
    React.createElement("p", { className: "stat-section__statTitle", style: { color: textColor } }, title),
    React.createElement("p", { className: "stat-section__statSubTitle", style: { color: textColor } }, subTitle)));
